import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Cases from "./pages/cases";
import AuditReport from "./pages/cases/auditing/auditReport";
import StudentReport from "./pages/cases/auditing/studentReport";
import RadiologistReport from "./pages/cases/auditing/radiologistReport";
import ClinicalCorrelation from "./pages/cases/auditing/clinicalCorrelation";
import TestHtmlRenderer from "./components/TestHtmlRenderer";

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Cases />} />
        <Route path="/cases/:url" element={<Cases />} />
        <Route path="/cases/auditing/auditReport/:id" element={<AuditReport />} />
        <Route path="/cases/auditing/studentReport/:id" element={<StudentReport />} />
        <Route path="/cases/auditing/radiologistReport/:id" element={<RadiologistReport />} />
        <Route path="/cases/auditing/clinicalCorrelation/:id" element={<ClinicalCorrelation />} />
        <Route path="/test-html" element={<TestHtmlRenderer />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;



